/*
 * Copyright (c) 2022 CalAmp Corp.  All Rights Reserved
 */
import React from 'react';
import {translate} from '@ion/core/src/locale/locale';
import {IconButton} from '../../components/buttons/IconButton';
import {DiscardFiltersIcon} from '../../icons/DiscardFiltersIcon';
import {IconSize} from '../../types/types';
import Tooltip from '../tooltip/Tooltip';

export const GridClearFiltersTooltip = function(props) {
  return <Tooltip arrow {...props} />;
};

// defines the admin container props ...
export type GridClearFiltersButtonProps = {
  onClearFilters: () => void;
  areFiltersApplied: boolean;
  size?: IconSize;
  disabled?: boolean;
};

/**
 * The GridClearFiltersButton provides the Clear Filter Button which will clear the grid API of its filter model.
 *
 * ```typescript
 *   import {GridClearFiltersButton} from '../../components/buttons/';
 *
 *   <GridClearFiltersButton onClearFilters={onClearFilters} />
 * ```
 */
export const GridClearFiltersButton = ({
  onClearFilters,
  areFiltersApplied,
  disabled = false,
  size = IconSize.medium
}: GridClearFiltersButtonProps) => {
  if (areFiltersApplied) {
    return (
      <GridClearFiltersTooltip title={translate('common:filters.clearFilters')}>
        <div>
          <IconButton disabled={disabled} icon={<DiscardFiltersIcon size={size} />}
            onClick={onClearFilters} />
        </div>
      </GridClearFiltersTooltip>
    );
  }
  return null;
};

export default GridClearFiltersButton;
